import template from './adpTabs.html';
import controller from './adpTabs.controller';
import './adpTabs.less';

let adpTabsComponent = {
  restrict: 'E',
  bindings: {
  	tabs: '<',
  	activeTab: '=?',	
  	hasBottomBorder: '@',
  },
  template,
  transclude: true,
  controller
};

export default adpTabsComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpTabs/adpTabs.component.js